import {
  POST_MESSAGE_MESSAGE_BOT,
  POST_MESSAGE_GO_TO_MODULE,
  POST_MESSAGE_SEND_CVARS,
  POST_MESSAGE_MESSAGE_USER,
  POST_MESSAGE_RESET_CHAT,
  POST_MESSAGE_CLEAR_CHAT,
  POST_MESSAGE_SENT_FROM_SDK_BEFORE_DISPLAY,
  POST_MESSAGE_SENT_FROM_SDK_BEFORE_SEND,
} from "constants";
import goToModule from "./postMessageGoToModule";
import sendCvars from "./postMessageSendCvars";
import messageBot from "./postMessageMessageBot";
import messageUser from "./postMessageMessageUser";
import resetChat from "./postMessageResetChat";
import clearChat from "./postMessageClearChat";
import receivedFromSdk from "./postMessageReceivedFromSdk";
import beforeSend from "./postMessageBeforeSend";

export default props => {
  switch (props.data.type) {
    case POST_MESSAGE_GO_TO_MODULE:
      goToModule(props);
      break;
    case POST_MESSAGE_SEND_CVARS:
      sendCvars(props);
      break;
    case POST_MESSAGE_MESSAGE_BOT:
      messageBot(props);
      break;
    case POST_MESSAGE_MESSAGE_USER:
      messageUser(props);
      break;
    case POST_MESSAGE_RESET_CHAT:
      resetChat(props);
      break;
    case POST_MESSAGE_CLEAR_CHAT:
      clearChat(props);
      break;
    case POST_MESSAGE_SENT_FROM_SDK_BEFORE_DISPLAY:
      receivedFromSdk(props);
      break;
    case POST_MESSAGE_SENT_FROM_SDK_BEFORE_SEND:
      beforeSend(props);
      break;
    default:
      break;
  }
};
